export enum TravelInsuranceType {
  SHORT_TERM = "SHORT_TERM",
  YEAR = "YEAR",
  CANCELLATION = "CANCELLATION",
}

export enum TravelRiskGroup {
  TOURIST = "TOURIST",
  SPORT = "SPORT",
  RISKY_SPORT = "RISKY_SPORT",
  EXTREME_SPORT = "EXTREME_SPORT",
  PROFESSIONAL_SPORT = "PROFESSIONAL_SPORT",
  MANUAL_WORK = "MANUAL_WORK",
  NON_MANUAL_WORK = "NON_MANUAL_WORK",
}

export enum TravelTerritorialValidity {
  EUROPE = "EUROPE",
  WORLD = "WORLD",
  WORLD_WITHOUT_USA_AND_CANADA = "WORLD_WITHOUT_USA_AND_CANADA",
  SVK = "SVK",
}

export enum TravelDestination {
  CZE = "CZE",
  AFG = "AFG",
  ALA = "ALA",
  ALB = "ALB",
  DZA = "DZA",
  ASM = "ASM",
  AND = "AND",
  AGO = "AGO",
  AIA = "AIA",
  ATA = "ATA",
  ATG = "ATG",
  ARG = "ARG",
  ARM = "ARM",
  ABW = "ABW",
  AUS = "AUS",
  AUT = "AUT",
  AZE = "AZE",
  BHS = "BHS",
  BHR = "BHR",
  BGD = "BGD",
  BRB = "BRB",
  BLR = "BLR",
  BEL = "BEL",
  BLZ = "BLZ",
  BEN = "BEN",
  BMU = "BMU",
  BTN = "BTN",
  BOL = "BOL",
  BES = "BES",
  BIH = "BIH",
  BWA = "BWA",
  BVT = "BVT",
  BRA = "BRA",
  IOT = "IOT",
  BRN = "BRN",
  BGR = "BGR",
  BFA = "BFA",
  BDI = "BDI",
  KHM = "KHM",
  CMR = "CMR",
  CAN = "CAN",
  CPV = "CPV",
  CYM = "CYM",
  CAF = "CAF",
  TCD = "TCD",
  CHL = "CHL",
  CHN = "CHN",
  CXR = "CXR",
  CCK = "CCK",
  COL = "COL",
  COM = "COM",
  COG = "COG",
  COD = "COD",
  COK = "COK",
  CRI = "CRI",
  CIV = "CIV",
  HRV = "HRV",
  CUB = "CUB",
  CUW = "CUW",
  CYP = "CYP",
  DNK = "DNK",
  DJI = "DJI",
  DMA = "DMA",
  DOM = "DOM",
  ECU = "ECU",
  EGY = "EGY",
  SLV = "SLV",
  GNQ = "GNQ",
  ERI = "ERI",
  EST = "EST",
  ETH = "ETH",
  FLK = "FLK",
  FRO = "FRO",
  FJI = "FJI",
  FIN = "FIN",
  FRA = "FRA",
  GUF = "GUF",
  PYF = "PYF",
  ATF = "ATF",
  GAB = "GAB",
  GMB = "GMB",
  GEO = "GEO",
  DEU = "DEU",
  GHA = "GHA",
  GIB = "GIB",
  GRC = "GRC",
  GRL = "GRL",
  GRD = "GRD",
  GLP = "GLP",
  GUM = "GUM",
  GTM = "GTM",
  GGY = "GGY",
  GIN = "GIN",
  GNB = "GNB",
  GUY = "GUY",
  HTI = "HTI",
  HMD = "HMD",
  VAT = "VAT",
  HND = "HND",
  HKG = "HKG",
  HUN = "HUN",
  ISL = "ISL",
  IND = "IND",
  IDN = "IDN",
  IRN = "IRN",
  IRQ = "IRQ",
  IRL = "IRL",
  IMN = "IMN",
  ISR = "ISR",
  ITA = "ITA",
  JAM = "JAM",
  JPN = "JPN",
  JEY = "JEY",
  JOR = "JOR",
  KAZ = "KAZ",
  KEN = "KEN",
  KIR = "KIR",
  PRK = "PRK",
  KOR = "KOR",
  XKX = "XKX",
  KWT = "KWT",
  KGZ = "KGZ",
  LAO = "LAO",
  LVA = "LVA",
  LBN = "LBN",
  LSO = "LSO",
  LBR = "LBR",
  LBY = "LBY",
  LIE = "LIE",
  LTU = "LTU",
  LUX = "LUX",
  MAC = "MAC",
  MKD = "MKD",
  MDG = "MDG",
  MWI = "MWI",
  MYS = "MYS",
  MDV = "MDV",
  MLI = "MLI",
  MLT = "MLT",
  MHL = "MHL",
  MTQ = "MTQ",
  MRT = "MRT",
  MUS = "MUS",
  MYT = "MYT",
  MEX = "MEX",
  FSM = "FSM",
  MDA = "MDA",
  MCO = "MCO",
  MNG = "MNG",
  MNE = "MNE",
  MSR = "MSR",
  MAR = "MAR",
  MOZ = "MOZ",
  MMR = "MMR",
  NAM = "NAM",
  NRU = "NRU",
  NPL = "NPL",
  NLD = "NLD",
  NCL = "NCL",
  NZL = "NZL",
  NIC = "NIC",
  NER = "NER",
  NGA = "NGA",
  NIU = "NIU",
  NFK = "NFK",
  MNP = "MNP",
  NOR = "NOR",
  OMN = "OMN",
  PAK = "PAK",
  PLW = "PLW",
  PSE = "PSE",
  PAN = "PAN",
  PNG = "PNG",
  PRY = "PRY",
  PER = "PER",
  PHL = "PHL",
  PCN = "PCN",
  POL = "POL",
  PRT = "PRT",
  PRT_MADEIRA = "PRT_MADEIRA",
  PRT_AZORES = "PRT_AZORES",
  PRI = "PRI",
  QAT = "QAT",
  REU = "REU",
  ROU = "ROU",
  RUS_EUROPE = "RUS_EUROPE",
  RUS_ASIA = "RUS_ASIA",
  RWA = "RWA",
  BLM = "BLM",
  SHN = "SHN",
  KNA = "KNA",
  LCA = "LCA",
  MAF = "MAF",
  SPM = "SPM",
  VCT = "VCT",
  WSM = "WSM",
  SMR = "SMR",
  STP = "STP",
  SAU = "SAU",
  SEN = "SEN",
  SRB = "SRB",
  SYC = "SYC",
  SLE = "SLE",
  SGP = "SGP",
  SXM = "SXM",
  SVN = "SVN",
  SLB = "SLB",
  SOM = "SOM",
  ZAF = "ZAF",
  SGS = "SGS",
  SSD = "SSD",
  ESP = "ESP",
  ESP_CANARY_ISLANDS = "ESP_CANARY_ISLANDS",
  LKA = "LKA",
  SDN = "SDN",
  SUR = "SUR",
  SJM = "SJM",
  SWZ = "SWZ",
  SWE = "SWE",
  CHE = "CHE",
  SYR = "SYR",
  TWN = "TWN",
  TJK = "TJK",
  TZA = "TZA",
  THA = "THA",
  TLS = "TLS",
  TGO = "TGO",
  TKL = "TKL",
  TON = "TON",
  TTO = "TTO",
  TUN = "TUN",
  TUR = "TUR",
  TKM = "TKM",
  TCA = "TCA",
  TUV = "TUV",
  UGA = "UGA",
  UKR = "UKR",
  ARE = "ARE",
  GBR = "GBR",
  USA = "USA",
  UMI = "UMI",
  URY = "URY",
  UZB = "UZB",
  VUT = "VUT",
  VEN = "VEN",
  VNM = "VNM",
  VGB = "VGB",
  VIR = "VIR",
  WLF = "WLF",
  ESH = "ESH",
  YEM = "YEM",
  ZMB = "ZMB",
  ZWE = "ZWE",
}

export enum TravelLuggageInsuranceAmount {
  ONE_THOUSAND = "ONE_THOUSAND",
  TWO_THOUSAND = "TWO_THOUSAND",
  THREE_THOUSAND = "THREE_THOUSAND",
  FOUR_THOUSAND = "FOUR_THOUSAND",
}

export enum TravelClientDiscountType {
  ISIC_CARD = "ISIC_CARD",
  EURO26_CARD = "EURO26_CARD",
  ITIC_CARD = "ITIC_CARD",
  UNION_HEALTH_INSURANCE_CLIENT = "UNION_HEALTH_INSURANCE_CLIENT",
}

export enum TravelAbandonedHouseholdType {
  HOUSE = "HOUSE",
  FLAT = "FLAT",
}

export enum TravelPetType {
  DOG = "DOG",
  CAT = "CAT",
  RABBIT = "RABBIT",
  BIRD = "BIRD",
}
